import { InfoLeagueProps } from '../leagues.props';
import { Diamond } from './Diamond';

export const DiamondLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_DIAMOND}`,
  icon: '💎',
  name: 'Diamante',
  description: 'La liga definitiva. El botín de los dioses.',
  active: false,
  color: '#FFD700',
  bgColor: '#8B0000',
  borderColor: '#8B0000',
  path: '/diamond',
  page: Diamond,
};
